import { capitalize } from '~/lib/utils/utils'

const min = (field, { length }) => `${capitalize(field)} is too short, enter min ${length} characters`
const required = field => `Please enter ${field}`

export default {
  messages: {
    required: 'Please enter your {_field_}.',
    birthday: 'Please enter your birthday.',
    email: 'Email address is invalid'
  },
  names: {
    schoolLevel: 'school level',
    degree: 'field of study',
    repassword: 'password',
    genderCustom: 'gender'
  },
  fields: {
    birthDay: {
      required: 'Please enter your birthday.',
      birthDay: 'Please enter a valid birthday.',
      age: 'You must be 13 years old.'
    },
    profileType: {
      oneOf: 'The selected profile type is invalid.',
      required: 'The selected profile type is invalid.'
    },
    gender: {
      oneOf: 'Please select your {_field_}.',
      required: 'Please select your {_field_}.'
    },
    genderCustom: {
      oneOf: 'Please enter your {_field_}.',
      required: 'Please enter your {_field_}.',
      alphaSpaces: 'Please use only letters or spaces.'
    },
    citizenship: {
      oneOf: 'Please select your citizenship.',
      required: 'Please select your citizenship.'
    },
    ethnicity: {
      oneOf: 'Please select your ethnicity.',
      required: 'Please select your ethnicity.'
    },
    militaryAffiliation: {
      oneOf: 'Please select your military affiliation.',
      required: 'Please select your military affiliation.'
    },
    schoolLevel: {
      required: 'Please select your {_field_}.'
    },
    degree: {
      required: 'Please select your {_field_}.'
    },
    password: {
      required: 'Please enter password',
      min
    },
    repassword: {
      required: 'Please enter password',
      min
    },
    zip: {
      required: 'Please enter zip code',
      min: 'Please enter 5 digit zip code'
    },
    phone: {
      required: 'Please enter phone number',
      min: 'Phone number is too short'
    },
    firstName: {
      required: 'Please enter first name'
    },
    lastName: {
      required: 'Please enter last name'
    },
    address: {
      required
    },
    address2: {
      required: 'Please enter address'
    },
    city: {
      required
    },
    stateName: {
      required: 'Please select state/province/region'
    },
    email: {
      required: 'Please enter email address'
    }
  }
}
